module.exports = __webpack_public_path__ + "img/user-large.a7867be9.svg";